export default __webpack_public_path__ + "static/media/Landing_Logo_Ispor.e0787eff.png";